/**
 * LimeSpot Custom Enhancement Script
 * Adds climate badges and "Ready to ship" indicators to LimeSpot product cards
 */

(function() {
  'use strict';

  // SVG icons
  const CLIMATE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clip-path="url(#clip0_64_787)">
      <path d="M4 6.75C3.61872 6.97013 3.32073 7.30993 3.15224 7.71668C2.98376 8.12344 2.9542 8.57442 3.06815 8.99969C3.1821 9.42496 3.43319 9.80074 3.78248 10.0688C4.13177 10.3368 4.55973 10.4821 5 10.4821C5.44027 10.4821 5.86823 10.3368 6.21752 10.0688C6.56681 9.80074 6.8179 9.42496 6.93185 8.99969C7.0458 8.57442 7.01624 8.12344 6.84776 7.71668C6.67928 7.30993 6.38128 6.97013 6 6.75V2.5C6 2.23478 5.89464 1.98043 5.70711 1.79289C5.51957 1.60536 5.26522 1.5 5 1.5C4.73478 1.5 4.48043 1.60536 4.29289 1.79289C4.10536 1.98043 4 2.23478 4 2.5V6.75Z" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4 4.5H6" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8 4.5H11" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.5 3V6" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_64_787">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>`;

  const POSITION_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
    <path d="M3.60715 11.3227C2.16725 11.3227 1 10.1991 1 8.81297C1 7.42738 2.16725 6.30379 3.60715 6.30379C3.82716 5.31736 4.61149 4.51232 5.66454 4.19153C6.71703 3.87131 7.87924 4.08349 8.71228 4.75137C9.54531 5.41757 9.92264 6.43479 9.70318 7.42122H10.2574C11.3284 7.42122 12.1967 8.29456 12.1967 9.3728C12.1967 10.4516 11.3284 11.3249 10.2569 11.3249H3.60715" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.0376 7.58918C11.6201 7.47346 12.1328 7.13107 12.4629 6.63734C12.793 6.1436 12.9134 5.53896 12.7977 4.95644C12.6819 4.37391 12.3396 3.86122 11.8458 3.53113C11.3521 3.20105 10.7474 3.08063 10.1649 3.19635C9.58239 3.31207 9.06969 3.65446 8.73961 4.1482" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.72803 1L9.72935 1.00667" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.9941 4.52026L15.0008 4.51894" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.85711 2.89011L6.84912 2.88477" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.1174 1.64646L13.1094 1.64111" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.3525 7.90088L14.3605 7.90622" stroke="#495920" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;

  const READY_TO_SHIP_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_64_747)">
      <path d="M4.16699 9.99992L8.33366 14.1666L16.667 5.83325" stroke="#AED34B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_64_747">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>`;

  /**
   * Fetch product metafields using a custom endpoint
   * We'll fetch the product page HTML and extract metafields from it
   */
  async function fetchProductMetafields(productHandle) {
    try {

      // Check if we have cached data
      if (window.productMetafieldsData && window.productMetafieldsData[productHandle]) {
        return window.productMetafieldsData[productHandle];
      }

      // Try to fetch JSON from the metafields view
      // Note: Shopify's ?view parameter doesn't work with JSON responses
      // So we skip this and go straight to HTML parsing

      // Fallback: Fetch the regular product page and parse HTML
      const htmlResponse = await fetch(`/products/${productHandle}`);
      if (!htmlResponse.ok) throw new Error('Product not found');

      const html = await htmlResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');


      // Try to find metafields in the HTML
      // Look for the card-product snippet that has the badges
      const climateBadge = doc.querySelector('.badge--climate');
      const positionBadge = doc.querySelector('.badge--position');
      const available = doc.querySelector('.price') !== null;

      let climate = null;
      let position = null;

      if (climateBadge) {
        // Get the text content and clean it up
        const clonedBadge = climateBadge.cloneNode(true);
        // Remove SVG elements
        const svg = clonedBadge.querySelector('svg');
        if (svg) svg.remove();

        const text = clonedBadge.textContent.trim();

        // Parse climate text like "Subtropical, +1 more" or just "Subtropical"
        if (text) {
          // Split by comma and take only the first part (before +X more)
          const parts = text.split(',').map(p => p.trim());
          // Filter out "+X more" parts
          const cleanParts = parts.filter(p => !p.match(/^\+\d+\s+more$/i));
          if (cleanParts.length > 0) {
            climate = cleanParts;
          }
        }
      }

      if (positionBadge) {
        // Get the text content and clean it up
        const clonedBadge = positionBadge.cloneNode(true);
        // Remove SVG elements
        const svg = clonedBadge.querySelector('svg');
        if (svg) svg.remove();

        const text = clonedBadge.textContent.trim();

        if (text) {
          position = text;
        }
      }

      const result = { handle: productHandle, climate, position, available };
      return result;
    } catch (error) {
      console.error('Error fetching product metafields:', error);
      return null;
    }
  }

  /**
   * Fetch product inventory data
   */
  async function fetchProductData(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) throw new Error('Product not found');
      return await response.json();
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }

  /**
   * Parse metafield value - handles both string and array formats
   */
  function parseMetafieldValue(value) {
    if (!value) return null;

    // If it's already an array, return it
    if (Array.isArray(value)) return value;

    // If it's a JSON string like '["Subtropical","+1 more"]', parse it
    if (typeof value === 'string') {
      // Try to parse as JSON array
      if (value.startsWith('[') && value.endsWith(']')) {
        try {
          const parsed = JSON.parse(value.replace(/'/g, '"'));
          return Array.isArray(parsed) ? parsed : [value];
        } catch (e) {
          // If parsing fails, clean up and split
          const cleaned = value.replace(/[\[\]"']/g, '');
          return cleaned.split(',').map(v => v.trim()).filter(v => v);
        }
      }
      // Single value string
      return [value];
    }

    return null;
  }

  /**
   * Create climate badge HTML
   */
  function createClimateBadge(climateValues) {
    if (!climateValues || climateValues.length === 0) return '';

    const climateCount = climateValues.length;
    let displayText = '';

    if (climateCount <= 1) {
      displayText = climateValues.map(c => c.charAt(0).toUpperCase() + c.slice(1)).join(', ');
    } else {
      displayText = climateValues[0].charAt(0).toUpperCase() + climateValues[0].slice(1);
      const remaining = climateCount - 1;
      displayText += `, +${remaining} more`;
    }

    return `
      <span class="limespot-badge--climate">
        ${CLIMATE_ICON}
        ${displayText}
      </span>
    `;
  }

  /**
   * Create position badge HTML
   */
  function createPositionBadge(position) {
    if (!position) return '';

    const positionText = position.replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
      <span class="limespot-badge--position">
        ${POSITION_ICON}
        ${positionText}
      </span>
    `;
  }

  /**
   * Create ready to ship badge HTML
   */
  function createReadyToShipBadge() {
    return `
     
    `;
  }

  /**
   * Enhance a single LimeSpot product item
   */
  async function enhanceProductItem(item) {
    try {

      // Log item structure

      // Check if already enhanced
      if (item.classList.contains('limespot-enhanced')) {
        

        // Check if badges were actually added
        const existingBadges = item.querySelector('.limespot-badges');
        const readyToShip = item.querySelector('.limespot-ready-to-ship');
        

        // If badges exist, skip. Otherwise, continue to add them
        if (existingBadges || readyToShip) {
          return;
        } else {
        }
      } else {
        item.classList.add('limespot-enhanced');
      }

      // Get product handle from the link
      const productLink = item.querySelector('a.ls-link, a[href*="/products/"]');

      if (!productLink) {
        return;
      }

      const productUrl = productLink.getAttribute('href');
      const productHandle = productUrl.split('/products/')[1]?.split('?')[0]?.split('&')[0];

      if (!productHandle) {
        return;
      }

      // Find the title element - we'll insert badges after it
      const titleElement = item.querySelector('.ls-title');
      const priceWrap = item.querySelector('.ls-price-wrap');
      const priceElement = item.querySelector('.ls-price');


      // Log all available elements for debugging

      if (!priceWrap || !priceElement) {

        // Try alternative selectors
        const altPriceWrap = item.querySelector('[class*="price"]');
        const altTitle = item.querySelector('[class*="title"], h3, h4');


        if (!altPriceWrap) {
          return;
        }
      }

      // Assume all products are in stock and show the badge
      // We'll fetch the actual data to verify
      let isInStock = true; // Default to true

      // Add ready to ship badge inside price-wrap initially
      const readyToShipDiv = document.createElement('div');
      readyToShipDiv.innerHTML = createReadyToShipBadge();
      readyToShipDiv.classList.add('limespot-ready-to-ship-inserted');
      priceWrap.appendChild(readyToShipDiv.firstElementChild);

      // Fetch both product inventory and metafields

      Promise.all([
        fetchProductData(productHandle),
        fetchProductMetafields(productHandle)
      ]).then(([productData, metafieldsData]) => {

        // Handle inventory/availability
        if (productData) {
          const firstAvailableVariant = productData.variants.find(v => v.available) || productData.variants[0];
          const actuallyInStock = firstAvailableVariant && firstAvailableVariant.available;

          // Check if product has pickupOnly tag (case-insensitive)
          const isPickupOnly = productData.tags && productData.tags.some(tag =>
            tag.toLowerCase() === 'pickuponly'
          );

          // Remove badge if not in stock OR if it's pickup only
          if (!actuallyInStock || isPickupOnly) {
            const badge = item.querySelector('.limespot-ready-to-ship');
            if (badge) {
              badge.remove();
            }
          }
        }

        // Generate badge HTML from metafields data
        let climateBadgeHTML = '';
        let positionBadgeHTML = '';

        if (metafieldsData) {
          // Create climate badge if available
          if (metafieldsData.climate) {
            const climateValues = parseMetafieldValue(metafieldsData.climate);
            climateBadgeHTML = createClimateBadge(climateValues);
          }

          // Create position badge if available
          if (metafieldsData.position) {
            positionBadgeHTML = createPositionBadge(metafieldsData.position);
          }
        }

        // Insert badges after title if we have any
        if ((climateBadgeHTML || positionBadgeHTML) && titleElement) {
          const badgesContainer = document.createElement('div');
          badgesContainer.className = 'limespot-badges';
          badgesContainer.innerHTML = climateBadgeHTML + positionBadgeHTML;

          // Insert after title
          titleElement.parentNode.insertBefore(badgesContainer, titleElement.nextSibling);

        }
      }).catch(error => {
        console.error('LimeSpot: Error fetching product data for', productHandle, error);
      });

    } catch (error) {
      console.error('LimeSpot enhancement error:', error);
    }
  }

  /**
   * Enhance all LimeSpot items in the carousel
   */
  function enhanceLimeSpotCarousel() {

    // Try multiple selectors to find LimeSpot container
    let limespotContainer = document.querySelector('.gh-lime-recommendation');

    if (!limespotContainer) {
      // Fallback: look for any element with LimeSpot in the class
      limespotContainer = document.querySelector('[class*="LimeSpot"], [class*="limespot"]');
    }

    if (!limespotContainer) {
      return;
    }


    // Try multiple selectors for product items
    let productItems = limespotContainer.querySelectorAll('.limespot-recommendation-box-item');

    if (productItems.length === 0) {
      // Fallback: try other possible selectors
      productItems = limespotContainer.querySelectorAll('[class*="LimeSpot_Item"], [class*="ls-item"]');
    }


    productItems.forEach((item, index) => {
      enhanceProductItem(item);
    });
  }

  /**
   * Initialize the enhancement
   */
  function init() {

    // Wait for LimeSpot to load
    if (typeof LimeSpot !== 'undefined') {
      enhanceLimeSpotCarousel();
    } else {
    }

    // Also observe for dynamic content changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          enhanceLimeSpotCarousel();
        }
      });
    });

    // Start observing the entire document for LimeSpot content
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Try again after delays to catch late-loading content
    setTimeout(() => {
      enhanceLimeSpotCarousel();
    }, 1000);

    setTimeout(() => {
      enhanceLimeSpotCarousel();
    }, 2000);

    setTimeout(() => {
      enhanceLimeSpotCarousel();
    }, 3000);

    setTimeout(() => {
      enhanceLimeSpotCarousel();
    }, 5000);
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also run when LimeSpot is ready
  window.addEventListener('limespot.ready', () => {
    init();
  });

})();
